import { useEffect, useState } from 'react';

export default function SecurePhone() {
    const [mounted, setMounted] = useState(false);

    useEffect(() => setMounted(true), []);

    if (!mounted) {
        return <span>+49 ...</span>;
    }

    return <a href="tel:+4915679763272">+49 15679 763272</a>;
}
